/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type AssetsSummaryProps = {
  formData: Record<string, any>;
};

const AssetsSummary = ({ formData }: AssetsSummaryProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>Vermögen</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"hasBankAccount"} sx={summaryStyle.scrollToAnchor} />
        Bankkonten
      </Grid>
      <Grid size={12}>
        {formData.hasBankAccount === "no" ? (
          "Keine Bankkonten"
        ) : (
          <>
            {formData.bankAccounts?.map((bankAccount: Record<string, any>, key: number) => (
              <React.Fragment key={key}>
                {bankAccount.type} von {bankAccount.owner} bei {bankAccount.name}, Guthaben: {bankAccount.amount} €
                <br />
                <br />
              </React.Fragment>
            ))}
          </>
        )}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"hasRealEstate"} sx={summaryStyle.scrollToAnchor} />
        Grundeigentum
      </Grid>
      <Grid size={12}>
        {formData.hasRealEstate === "no" ? (
          "Kein Grundeigentum"
        ) : (
          <>
            Größe: {formData.realEstate1Size} m²
            <br />
            {formData.realEstate1NumberApartments === 0 && "Keine Wohneinheiten"}
            {formData.realEstate1NumberApartments === 1 && "Eine Wohneinheit"}
            {formData.realEstate1NumberApartments > 1 && formData.realEstate1NumberApartments + " Wohneinheiten"}
            <br />
            Anschrift/Bezeichnung: {formData.realEstate1Location}
            <br />
            {formData.realEstate1Ownership}
            <br />
            Wert: {formData.realEstate1Value} €<br />
          </>
        )}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"hasVehicles"} sx={summaryStyle.scrollToAnchor} />
        Fahrzeuge
      </Grid>
      <Grid size={12}>
        {formData.hasVehicles === "no" ? (
          "Keine Fahrzeuge"
        ) : (
          <>
            {formData.vehicles?.map((vehicle: Record<string, any>, key: number) => (
              <React.Fragment key={key}>
                {vehicle.make}
                <br />
                Baujahr {vehicle.manufactured}, gekauft {vehicle.purchased}
                <br />
                Fahrleistung {vehicle.mileage} km
                <br />
                {vehicle.ownership}
                <br />
                Wert: {vehicle.value} €<br />
                <br />
              </React.Fragment>
            ))}
          </>
        )}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"cashAmount"} sx={summaryStyle.scrollToAnchor} />
        Bargeld oder Wertgegenstände
      </Grid>
      <Grid size={12}>
        Bargeld: {formData.cashAmount > 0 && formData.cashAmount + " €"}
        {formData.cashAmount === 0 && "nicht vorhanden"}
        <br />
        {formData.hasValuables === "no" ? (
          "Keine Wertgegenstände"
        ) : (
          <>
            {formData.valuables?.map((valuable: Record<string, any>, key: number) => (
              <React.Fragment key={key}>
                <br />
                {valuable.name}
                <br />
                {valuable.ownership}
                <br />
                Wert: {valuable.value} €<br />
              </React.Fragment>
            ))}
          </>
        )}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"hasPensionInsurance"} sx={summaryStyle.scrollToAnchor} />
        Lebens- und Rentenversicherungen
      </Grid>
      <Grid size={12}>
        {formData.hasPensionInsurance === "no" ? (
          "Keine Lebensversicherungen"
        ) : (
          <>
            {formData.pensionInsurances?.map((pensionInsurance: Record<string, any>, key: number) => (
              <React.Fragment key={key}>
                <br />
                {pensionInsurance.name}
                <br />
                Versicherungsnehmer: {pensionInsurance.policyHolder}
                <br />
                Abschlussdatum: {pensionInsurance.date}
                <br />
                Wert: {pensionInsurance.value} €<br />
              </React.Fragment>
            ))}
          </>
        )}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"hasOtherAssets"} sx={summaryStyle.scrollToAnchor} />
        Sonstige Vermögenswerte
      </Grid>
      <Grid size={12}>
        {formData.hasOtherAssets === "no" ? (
          "Keine weiteren Vermögenswerte"
        ) : (
          <>
            {formData.otherAssets?.map((otherAsset: Record<string, any>, key: number) => (
              <React.Fragment key={key}>
                <br />
                {otherAsset.name}
                <br />
                {otherAsset.ownership}
                <br />
                Wert: {otherAsset.value} €<br />
              </React.Fragment>
            ))}
          </>
        )}
      </Grid>
    </>
  );
};

export default AssetsSummary;
